import React from "react"
import { motion, MotionProps } from "framer-motion"

interface Props {
  children: React.ReactNode
  delay?: number
}

export const FadeInWhenInView: React.FC<Props> = ({ delay = 0, children }) => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: true }}
      transition={{ duration: 1.3, delay: delay }}
    >
      {children}
    </motion.div>
  )
}

export const FadeInFromLeftWhenInView: React.FunctionComponent<Props> = ({ children, delay }) => {
  return (
    <motion.div
      initial={{ opacity: 0, x: "-15vw" }}
      whileInView={{ opacity: 1, x: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 1.3, delay: delay ?? 0 }}
    >
      {children}
    </motion.div>
  )
}
